/** Strip to alphanumeric uppercase — mirrors API `formatPartNumber`. */
export function formatPartNumber(partNumber: string): string {
    return partNumber.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().trim();
}
